var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8682 24.433C31.9058 18.552 31.557 9.80801 26.0932 4.35267C20.3193 -1.45089 10.9417 -1.45089 5.1291 4.35267C-0.683487 10.1562 -0.644736 19.5193 5.1291 25.2842C10.5929 30.7395 19.3506 31.0877 25.2407 26.058L33.3783 34.2216L35.0058 32.5966L26.8682 24.433ZM6.75663 23.6592C1.87405 18.7842 1.87405 10.8526 6.75663 5.97766C11.6392 1.10268 19.5831 1.10268 24.4656 5.97766C29.3095 10.8913 29.2707 18.7842 24.3494 23.6592C19.4668 28.4568 11.6392 28.4568 6.75663 23.6592Z",
    fill: "currentColor"
  })));
};
export default SvgSearch;